import React from "react";
import styles from "./Solutions.module.css";
import { useTranslation } from "react-i18next";
import { ReactComponent as DocGptIcon } from "../../../assets/DocGptIcon.svg";
import { ReactComponent as ContaGptIcon } from "../../../assets/ContaGptIcon.svg";
import { ReactComponent as VitaeGptIcon } from "../../../assets/VitaeGptIcon.svg";
import { ReactComponent as ClinicGptIcon } from "../../../assets/ClinicGptIcon.svg";
import { ReactComponent as LegalGptIcon } from "../../../assets/LegalGptIcon.svg";
import { ReactComponent as IndustriaGptIcon } from "../../../assets/IndustriaGptIcon.svg";
import { ReactComponent as AutoGptIcon } from "../../../assets/AutoGptIcon.svg";
import { ReactComponent as TalkGptIcon } from "../../../assets/TalkGptIcon.svg";
import { ReactComponent as DeliverGptIcon } from "../../../assets/DeliverGptIcon.svg";
import { ReactComponent as EduGptIcon } from "../../../assets/EduGptIcon.svg";
import { ReactComponent as FoundGptIcon } from "../../../assets/FoundGptIcon.svg";
import { ReactComponent as RealtyGptIcon } from "../../../assets/RealtyGptIcon.svg";
import { ReactComponent as TicketGptIcon } from "../../../assets/TicketGptIcon.svg";
import { ReactComponent as ObraGptIcon } from "../../../assets/ObraGptIcon.svg";
import { ReactComponent as AuditGptIcon } from "../../../assets/AuditGptIcon.svg";
import { ReactComponent as FlowGptIcon } from "../../../assets/FlowGptIcon.svg";
import { ReactComponent as SignGptIcon } from "../../../assets/SignGptIcon.svg";
import { ReactComponent as EnergiaGptIcon } from "../../../assets/EnergiaGptIcon.svg";
import { ReactComponent as MediaGptIcon } from "../../../assets/MediaGptIcon.svg";
import { ReactComponent as TokenGptIcon } from "../../../assets/TokenGptIcon.svg";

import { ReactComponent as SolutionsDevelopmentIcon } from "../../../assets/SolutionsDevelopmentIcon.svg";
// import { ReactComponent as SecurityCloudIcon } from "../../../assets/SecurityCloudIcon.svg";
import { ReactComponent as TechnicalSupport } from "../../../assets/TechnicalSupport.svg";
// import { ReactComponent as HelpCenter } from "../../../assets/HelpCenter.svg";
import Button from "../../Button/Button";
import { useNavigate } from "react-router-dom";
import HeaderCard from "../../HeaderCard/HeaderCard";

const Solutions = ({showSolutions, setShowSolutions,isMobile}) => {
  const [t] = useTranslation("Landing");

  const solutionsPlatform = [
    {
      name: t("solutionsDevelopment"),
      desc: t("solutionsDevelopmentDesc"),
      icon: <SolutionsDevelopmentIcon />,
    },
   
    {
      name: t("technicalSupport"),
      desc: t("technicalSupportDesc3"),
      icon: <TechnicalSupport />,
    },

  ];

  const solutions = [
    {
      name: "DocGPT",
      desc: t("docgptDesc"),
      btnText: t("docgptBtnText"),
      icon: <DocGptIcon />,
      url: "/go/docgpt",
    },
    {
      name: "ContaGPT",
      desc: t("contagptDesc"),
      btnText: t("contagptBtnText"),
      icon: <ContaGptIcon />,
      url: "/go/contagpt",
    },
    {
      name: "VitaeGPT",
      desc: t("vitaegptDesc"),
      btnText: t("vitaegptBtnText"),
      icon: <VitaeGptIcon />,
      url: "/go/vitaegpt",
    },
    {
      name: "ClinicGPT",
      desc: t("clinicgptDesc"),
      btnText: t("clinicgptBtnText"),
      icon: <ClinicGptIcon />,
      url: "/go/clinicgpt",
    },
    {
      name: "LegalGPT",
      desc: t("legalgptDesc"),
      btnText: t("legalgptBtnText"),
      icon: <LegalGptIcon />,
      url: "/go/legalgpt",
    },
    {
      name: "IndustriaGPT",
      desc: t("industriagptDesc"),
      btnText: t("industriagptBtnText"),
      icon: <IndustriaGptIcon />,
      url: "/go/industriagpt",
    },
    {
      name: "AutoGPT",
      desc: t("autogptDesc"),
      btnText: t("autogptBtnText"),
      icon: <AutoGptIcon />,
      url: "/go/autogpt",
    },
    {
      name: "TalkGPT",
      desc: t("talkgptDesc"),
      btnText: t("talkgptBtnText"),
      icon: <TalkGptIcon />,
      url: "/go/talkgpt",
    },
    {
      name: "DeliverGPT",
      desc: t("delivergptDesc"),
      btnText: t("delivergptBtnText"),
      icon: <DeliverGptIcon />,
      url: "/go/delivergpt",
    },
    {
      name: "EduGPT",
      desc: t("edugptDesc"),
      btnText: t("edugptBtnText"),
      icon: <EduGptIcon />,
      url: "/go/edugpt",
    },
    {
      name: "FoundGPT",
      desc: t("foundgptDesc"),
      btnText: t("foundgptBtnText"),
      icon: <FoundGptIcon />,
      url: "/go/foundgpt",
    },
    {
      name: "RealtyGPT",
      desc: t("realtygptDesc"),
      btnText: t("realtygptBtnText"),
      icon: <RealtyGptIcon />,
      url: "/go/realtygpt",
    },
    {
      name: "TicketGPT",
      desc: t("ticketgptDesc"),
      btnText: t("ticketgptBtnText"),
      icon: <TicketGptIcon />,
      url: "/go/ticketgpt",
    },
    {
      name: "ObraGPT",
      desc: t("obragptDesc"),
      btnText: t("obragptBtnText"),
      icon: <ObraGptIcon />,
      url: "/go/obragpt",
    },
    {
      name: "AuditGPT",
      desc: t("auditgptDesc"),
      btnText: t("auditgptBtnText"),
      icon: <AuditGptIcon />,
      url: "/go/auditgpt",
    },
    {
      name: "FlowGPT",
      desc: t("flowgptDesc"),
      btnText: t("flowgptBtnText"),
      icon: <FlowGptIcon />,
      url: "/go/flowgpt",
    },
    {
      name: "SignGPT",
      desc: t("signgptDesc"),
      btnText: t("signgptBtnText"),
      icon: <SignGptIcon />,
      url: "/go/signgpt",
    },
    {
      name: "EnergiaGPT",
      desc: t("energiagptDesc"),
      btnText: t("energiagptBtnText"),
      icon: <EnergiaGptIcon />,
      url: "/go/energiagpt",
    },
    {
      name: "MediaGPT",
      desc: t("mediagptDesc"),
      btnText: t("mediagptBtnText"),
      icon: <MediaGptIcon />,
      url: "/go/mediagpt",
    },
    {
      name: "TokenGPT",
      desc: t("tokengptDesc"),
      btnText: t("tokengptBtnText"),
      icon: <TokenGptIcon />,
      url: "/go/tokengpt",
    },
  ];
  const navigate = useNavigate()

  return (
    <div className={styles.solutionsContainer} style={{
      display:showSolutions && 'flex'
    }}>
    

    <div className={styles.container}>
    <div className={styles.content}>
      {isMobile && (

        <HeaderCard
        setState={setShowSolutions}
        title={t('solutions')}
        headerStyle={{
          width: "100%",
          padding: "0",
          position:"initial"
        }}
        ></HeaderCard>
      )}
      <div className={styles.headerSolution}>
         <p>{t("successStories")}</p>
        <span>{t("solutionRespondsDayToDay")}</span>
      </div>

        <div className={styles.solutionsList}>
          {solutions.map((solution, index) => (
            <div 
            key={index} 
            className={styles.solutionCard}
             onClick={(e) => {
              e.stopPropagation()
               setShowSolutions(false)
              navigate(solution.url)
             }}
             >
              <div className={styles.infoSolution}>
                <div className={styles.icon}>{solution.icon}</div>
                <h3>{solution.name}</h3>
              </div>
              <p>{solution.desc}</p>
            
              <Button headerStyle={{
                padding:"5px",
                fontSize:"13px"
              }}>
                {solution.btnText}
              </Button>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.content}>
     
      <div className={styles.headerSolution}>
         <p>{t("infrastructureAndSupport")}</p>
        <span>{t("infrastructureAllowsForScaling")}</span>
      </div>
     
        <div 
        className={`${styles.solutionsList} ${styles.bottom}`}
        onClick={() => {
          setShowSolutions(false)
          navigate('/help')
        }}
        >
          {solutionsPlatform.map((solution, index) => (
            <div key={index} className={styles.solutionCard} >
                 <div className={styles.infoSolution}>
                <div className={styles.icon}>{solution.icon}</div>
                <h3 className={styles.textSolutions}>{solution.name}</h3>
              </div>
              <p>{solution.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default Solutions;
